// Free shipping threshold in cents and max weight in grams
const freeShippingThreshold = 7500;
const maxWeightForFreeShipping = 20000; // 2250 kg in grams

// Function to update both the cart message and progress bar
function updateCartMessageAndProgressBar(cartTotal, cartWeight) {
  const messageElement = document.getElementById('dynamic-message');
  const bar = document.getElementById('progress');
  const progressBar = document.getElementById('progress-bar');

  // Check if cart weight exceeds max weight for free shipping
  if (cartWeight > maxWeightForFreeShipping) {
    // Hide progress bar and update message for heavy orders
    progressBar.style.display = 'none';
    bar.style.display = 'none';
    messageElement.innerHTML = '<strong>Bulk Delivery:</strong> <span style="font-size:0.8em;">Your order will be dispatched in multiple parcels</span>';
  } else {
    // Show progress bar and calculate cart percentage toward free shipping
    progressBar.style.display = 'block';
    bar.style.display = 'block';
    const cartPercent = Math.min((cartTotal / freeShippingThreshold) * 100, 100);

    // Update progress bar width and ARIA value
    progressBar.style.width = `${cartPercent}%`;
    progressBar.setAttribute('aria-valuenow', cartPercent);

    // Generate the message based on cart total
    let message = '';
    if (cartTotal >= freeShippingThreshold) {
      message = 'You qualify for <strong>Free Delivery!</strong>';
    } else {
      const remaining = (freeShippingThreshold - cartTotal) / 100;
      message = `Spend <strong>£${remaining.toFixed(2)}</strong> more to qualify for <strong>Free Delivery*</strong>`;
    }

    // Apply the message with bold styling
    messageElement.innerHTML = message;
  }
}

// Function to fetch the latest cart information and update the elements
function fetchCartAndUpdate() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      updateCartMessageAndProgressBar(cart.total_price, cart.total_weight);
    });
}

// Initial call to set up the message and progress bar when the cart drawer opens
document.addEventListener('DOMContentLoaded', function() {
  fetchCartAndUpdate();
});

// Update the message and progress bar each time an item is added or removed from the cart drawer
document.addEventListener('cart:updated', function() {
  fetchCartAndUpdate();
});

// Listen for items added to the cart from the product page
document.addEventListener('ajaxProduct:added', function(evt) {
  fetchCartAndUpdate();
});
